export * from './main.component';
export * from './main-resolver.service';
export * from './alarm-notification/alarm-notification.component';
